module.exports = __webpack_public_path__ + "static/media/buyer3.ac499057.jpg";